import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fetchUserPreferencesEpic } from './fetchUserPreferencesEpic';
import { resetUserPreferences } from './resetUserPreferencesEpic';
import { saveUserPreferences } from './saveUserPreferencesEpic';
import { updateLanguageForAccessibilityEpic } from './updateLanguageForAccessibilityEpic';
import { updateThemeEpic } from './updateThemeEpic';
import { updateUserPreferencesAvailableCurrenciesEpic } from './updateUserPreferencesAvailableCurrenciesEpic';

export const userPreferencesEpics = () =>
  withAppCrashIfException(
    'userPreferences',
    combineEpics(
      withAppCrashIfException('fetchUserPreferencesEpic', fetchUserPreferencesEpic()),
      withAppCrashIfException('saveUserPreferences', saveUserPreferences()),
      withAppCrashIfException('resetUserPreferences', resetUserPreferences()),
      withAppCrashIfException('updateThemeEpic', updateThemeEpic()),
      withAppCrashIfException('updateLanguageForAccessibilityEpic', updateLanguageForAccessibilityEpic()),
      withAppCrashIfException(
        'updateUserPreferencesAvailableCurrenciesEpic',
        updateUserPreferencesAvailableCurrenciesEpic(),
      ),
    ),
  );
